import React, { useContext } from "react";
import { useSelector } from "react-redux";
import Moment from "react-moment";
import { Header, Label } from "semantic-ui-react";
import { RecordingContext } from "../pages/RecordingPage";
import { statusColor, statusText } from "../../constants";

const RecordingInfo = () => {
  const { recording } = useContext(RecordingContext);
  const reviewer = useSelector((state) => state.mode.reviewer);
  return (
    <div style={infoSegmentStyle}>
      {/* text info section */}
      <div style={infoRowStyle}>
        <Header
          as="h2"
          content={`№ ${recording.number}`}
          style={flexItemStyle(20)}
        />
        <InfoItem text="Filename:" value={recording.filename} />
        {reviewer && recording.user_key && (
          <InfoItem
            text="Recorded at:"
            value={
              <Moment
                date={recording.recorded_at}
                format="DD-MM-YYYY HH:mm Z"
              />
            }
          />
        )}
      </div>
      {/* status section */}
      <div style={infoRowStyle}>
        <InfoItem
          text="Status:"
          value={
            <Label
              style={{ marginLeft: 0 }}
              color={statusColor(recording.user_status)}
              content={statusText(recording.user_status)}
            />
          }
        />
        {reviewer && (
          <InfoItem
            text="Reviewer status:"
            value={
              <Label
                style={{ marginLeft: 0 }}
                color={statusColor(recording.reviewer_status)}
                content={recording.reviewer_status}
              />
            }
          />
        )}
      </div>
    </div>
  );
};

const InfoItem = ({ text, value, width }) => (
  <div style={flexItemStyle(width)}>
    <Header as="h4">
      {text}
      <Header sub content={value} />
    </Header>
  </div>
);

const infoSegmentStyle = {
  display: "flex",
  flexDirection: "column",
  marginTop: "2%",
};

const infoRowStyle = {
  display: "flex",
  flexWrap: "nowrap",
  justifyContent: "flex-start",
  marginBottom: "20px",
};

const flexItemStyle = (width) => ({
  width: `${width}%`,
  marginRight: "5%",
});

export default RecordingInfo;
